<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
        :footer-props="globalFooterOptions"
        :headers="headers"
        :items="items"
        :items-per-page="globalItemsPerPage"
        :loading="loading"
        no-data-text="No Pending Actions"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        style="margin-bottom: 80px;"
        >
          <template v-slot:item.type="{ item }" >{{ translateAction(item.type) }}</template>
          <template v-slot:item.timeCreated="{ item }" >{{ formatDateTime(item.timeCreated) }}</template>
          <template v-slot:item.actions="{ item }" style="width: 1px;">
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click.stop="actionApprove(item)" icon><v-icon>done</v-icon></v-btn>
              </template>
              <v-card><v-card-text>
                Approve the request
              </v-card-text></v-card>
            </v-menu>
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click.stop="actionDeny(item)" icon><v-icon>clear</v-icon></v-btn>
              </template>
              <v-card><v-card-text>
                Reject the request
              </v-card-text></v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>

</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      headers: [
        { text: 'Type', value: 'type' },
        { text: 'Resource', value: 'creatorName', sortable: false },
        { text: 'Created', value: 'timeCreated' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      errorText: '',
      items: [],
      loading: false,
      options: {},
      totalItems: 0
    }
  },

  created () {
    this.getData()
  },

  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },

  methods: {
    getData: function () {
      if (this.options.page !== undefined) {
        this.loading = true

        var params = {}
        if (this.options.itemsPerPage > 0) {
          params.page = this.options.page - 1
          params.limit = this.options.itemsPerPage
        }

        if (this.options.sortBy.length > 0) {
          params.sort = ''
          if (this.options.sortDesc[0]) {
            params.sort = '-'
          }
          params.sort = params.sort + this.options.sortBy[0]
        }

        ApiRequests.actionQuery(params).then(r => {
          this.items = r.data
          this.totalItems = parseInt(r.headers['x-total-count'])
          this.loading = false
        })
      }
    },

    actionApprove: function (item) {
      ApiRequests.actionApprove(item._id).then(r => {
        this.errorText = this.translateAction(item.type) + ' approved'
        this.getData()
      }).catch(e => {
        this.errorText = 'action resolution failed: ' + e.response.data
      })
    },

    actionDeny: function (item) {
      ApiRequests.actionDeny(item._id).then(r => {
        this.errorText = this.translateAction(item.type) + ' denied'
        this.getData()
      }).catch(e => {
        this.errorText = 'action resolution failed: ' + e.response.data
      })
    }
  }
}
</script>
